import { useEffect, useState } from 'react';

export interface UseLazyLoadReturnType {
  isAtBottom: boolean;
}

export const useLazyLoad = (): UseLazyLoadReturnType => {
  const lazyloadBox = document.getElementById('lazy-load');
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    if (!lazyloadBox) return;
    const handleScroll = () => {
      setIsAtBottom(
        lazyloadBox.scrollHeight - 1 <=
          lazyloadBox.scrollTop + lazyloadBox.clientHeight
      );
    };
    lazyloadBox.addEventListener('scroll', handleScroll);
    return () => lazyloadBox.removeEventListener('scroll', handleScroll);
  }, [lazyloadBox]);

  return { isAtBottom };
};
